import { UiTourType } from '@booking-booster-client/models';
import { settingsAdvertisersParameters } from './steps';

export const SettingsAdvertisersParametersTour: UiTourType = {
  slug: 'settings-advertisers-parameters',
  steps: settingsAdvertisersParameters,
  nextStep: 'settings/balance',
  viewingRequired: true,
};
